var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:'badge ' + _vm.badgeClass},[_vm._v(" "+_vm._s(_vm.totalPax)+" / "+_vm._s(_vm.maxSize)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }